class BESSAppUtils {
    static dismissActivePopover() {
        BESSAppTooltip.close();
    }
}